<template>
  <div
    class="app-container"
    :class="{ 'has-sidebar': user }"
  >
    <Sidebar
      v-if="user"
      :user="user"
    />
    <div class="main-wrapper">
      <AppHeader
        v-if="user"
        :user="user"
      />
      <main
        class="content-area"
        :class="{ 'content-padding': user, 'container mt-3': !user }"
      >
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppHeader from "./components/dashboard/AppHeader.vue";
import Sidebar from "./components/dashboard/Sidebar.vue";
import { getCurrentUser } from "./composables/CurrentUser";
import { isAuthenticated } from "./services/auth";
import { watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const { user } = getCurrentUser();

watch(
  () => route.path,
  () => {
    if (!isAuthenticated()) {
      user.value = null;
    }
  }
);
</script>

<style lang="scss">
.app-container {
  display: flex;
  min-height: 100vh;
  background-color: #f4f7fe;

  &.has-sidebar {
    .main-wrapper {
      margin-left: 260px;
      width: calc(100% - 260px);
    }
  }
}

.main-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: all 0.3s ease;
}

.content-area {
  flex: 1;

  &.content-padding {
    padding: 1.4rem !important;
  }
}

/* Global utility classes for modern look */
.card {
  border: none !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  .card-header {
    background-color: transparent !important;
    border-bottom: 1px solid #f1f3f5 !important;
    padding: 1.15rem 1.4rem !important;
    font-weight: 700 !important;
    color: #1e1e2d !important;
  }

  .card-body {
    padding: 1.4rem !important;
  }
}

.btn {
  border-radius: 10px !important;
  padding: 0.55rem 1.1rem !important;
  font-weight: 600 !important;
  transition: all 0.2s ease !important;

  &-primary {
    background: linear-gradient(135deg, #4c6ef5 0%, #364fc7 100%) !important;
    border: none !important;
    box-shadow: 0 4px 12px rgba(76, 110, 245, 0.2) !important;

    &:hover {
      transform: translateY(-1px) !important;
      box-shadow: 0 6px 15px rgba(76, 110, 245, 0.3) !important;
    }
  }
}
</style>
